<template>
    <div>
        <breadcrumbs />
        <user-settings />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import UserSettings from '~src/components/account/UserSettings.vue'

    @Component({
        components: {
            UserSettings,
            Breadcrumbs,
        },
    })
    export class SettingsPage extends Vue {}

    export default SettingsPage
</script>
